import React from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import "../../Style/Components/calender.module.scss";
import Icon from "../icons";

export default function DatePickerSingle(props) {
  return (
    <div className=" position-relative w-100">
      {props.label && (
        <label
          className={
            props.labelStyle
              ? props.labelStyle
              : "e-text-black e-primary-font-poppins  e-font-weight-500  e-font-14 pb-1"
          }
        >
          {props.label}
          {props.require && <span className="text-danger">*</span>}
        </label>
      )}
      <div
        className={`w-100 e-border-radius-8 ${
          props.error ? "e-border-1px-ruby" : "e-border-1px-silver "
        }`}
      >
        <DatePicker
          selected={props.startDate}
          onChange={(date) => props.onChange(date)}
          //   className="date-picker-single"
          placeholderText={props.placeholder}
          maxDate={new Date()}
        />
      </div>
      <div className=" position-absolute calender-icon-single-picker">
        <Icon icon="calender" size="16px" color="#bbbbbb" />
      </div>
      {props.error && (
        <p className="mb-0 e-font-12 text-danger e-primary-font-poppins  pt-1">
          {props.error}
        </p>
      )}
    </div>
  );
}
